import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction';

import Icon from 'components/Icon';

import {
  MemberWrapper,
  MemberText,
  MemberInfo,
  Name,
  ButtonWrapper,
  ButtonStyled,
} from 'apps/group/styles';
import { WrapperIcon } from 'apps/group/views/invitation';

export const GroupInvite = withNamespaces()(
  observer(({ invite, group }) => {
    const { id, displayName } = invite;
    const { RemoveInvite } = group;

    /*
     * Add check for canDelete later.
     * By now, if an invitation is displayed, it can be deleted.
     */
    // FIXME
    const button = (
      <ButtonStyled
        onClick={e => {
          e.preventDefault();
          modalStore.SetModalComponent(ConfirmAction, {
            callBack: RemoveInvite,
            callBackArgs: id,
            title: 'withdraw this Invitation?',
            undo: true,
          });
        }}
        size='small'
        variant='destructive'
        text={<Trans>Remove</Trans>}
      />
    );

    return (
      <MemberWrapper intrinsic>
        <MemberInfo>
          <WrapperIcon>
            <Icon name='email' />
          </WrapperIcon>
          <MemberText>
            <Name>{displayName} (pending)</Name>
          </MemberText>
        </MemberInfo>
        <ButtonWrapper>{button}</ButtonWrapper>
      </MemberWrapper>
    );
  }),
);
